import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Select from '../../components/ui/Select';
import Input from '../../components/ui/Input';
import Header from '../../components/ui/Header';
import MobileNav from '../../components/ui/MobileNav';
import QuickActions from '../../components/ui/QuickActions';
import CampaignCard from './components/CampaignCard';
import CampaignTable from './components/CampaignTable';
import MilestoneTracker from './components/MilestoneTracker';
import CampaignAnalytics from './components/CampaignAnalytics';
import MessagePanel from './components/MessagePanel';
import PaymentManagement from './components/PaymentManagement';
import DisputeResolution from './components/DisputeResolution';

const CampaignManagement = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams?.get('tab') || 'active');
  const [viewMode, setViewMode] = useState('table');
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [showMilestones, setShowMilestones] = useState(false);
  const [showMessages, setShowMessages] = useState(false);
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [showPayments, setShowPayments] = useState(false);
  const [showDispute, setShowDispute] = useState(false);

  const campaigns = [
  {
    id: 1,
    title: "Yeni Single Lansmanı",
    type: "Instagram Reels",
    influencerName: "Ayşe Yılmaz",
    influencerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15f94130f-1763296604240.png",
    influencerAvatarAlt: "Profesyonel kadın influencer Ayşe Yılmaz'ın gülümseyen portre fotoğrafı, uzun kahverengi saçlı",
    coverImage: "https://images.unsplash.com/photo-1668609045515-ebf86dd88c8e",
    coverImageAlt: "Modern müzik stüdyosu ekipmanları ve mikrofon kurulumu, profesyonel aydınlatma ile",
    budget: "₺5.000",
    reach: "250K takipçi",
    progress: 75,
    deadline: "15/12/2025",
    status: "active"
  },
  {
    id: 2,
    title: "Album Tanıtım Kampanyası",
    type: "YouTube Video",
    influencerName: "Mehmet Demir",
    influencerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f2a7eabd-1763301609109.png",
    influencerAvatarAlt: "Genç erkek influencer Mehmet Demir'in profesyonel fotoğrafı, kısa siyah saçlı ve gülümseyen",
    coverImage: "https://images.unsplash.com/photo-1537372808453-6fdabf1bd2ad",
    coverImageAlt: "Renkli albüm kapağı tasarımı, modern grafik öğeler ve müzik teması ile",
    budget: "₺12.000",
    reach: "500K takipçi",
    progress: 45,
    deadline: "20/12/2025",
    status: "active"
  },
  {
    id: 3,
    title: "Konser Promosyonu",
    type: "TikTok Video",
    influencerName: "Zeynep Kaya",
    influencerAvatar: "https://images.unsplash.com/photo-1538709050556-230cc2c6b21f",
    influencerAvatarAlt: "Dinamik kadın influencer Zeynep Kaya'nın enerjik portresi, sarı saçlı ve neşeli",
    coverImage: "https://images.unsplash.com/photo-1720292060310-c7a938601ae6",
    coverImageAlt: "Canlı konser sahne görüntüsü, renkli ışıklar ve kalabalık izleyici kitlesi",
    budget: "₺8.500",
    reach: "380K takipçi",
    progress: 30,
    deadline: "25/12/2025",
    status: "pending"
  },
  {
    id: 4,
    title: "Müzik Video Lansmanı",
    type: "Instagram Story",
    influencerName: "Can Özkan",
    influencerAvatar: "https://images.unsplash.com/photo-1726597394681-3b55591d8f2a",
    influencerAvatarAlt: "Genç erkek influencer Can Özkan'ın cool portresi, kahverengi saçlı ve güneş gözlüklü",
    coverImage: "https://images.unsplash.com/photo-1558918152-e03aa713d3fd",
    coverImageAlt: "Profesyonel müzik video çekimi, sinematik aydınlatma ve modern set tasarımı",
    budget: "₺6.200",
    reach: "180K takipçi",
    progress: 100,
    deadline: "10/12/2025",
    status: "completed"
  },
  {
    id: 5,
    title: "Remix Tanıtımı",
    type: "Twitter Thread",
    influencerName: "Elif Şahin",
    influencerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d341f26d-1763295003987.png",
    influencerAvatarAlt: "Profesyonel kadın influencer Elif Şahin'in zarif portresi, siyah saçlı ve profesyonel makyajlı",
    coverImage: "https://images.unsplash.com/photo-1601334511716-ae9691db68fe",
    coverImageAlt: "DJ ekipmanları ve müzik prodüksiyon setup'ı, neon ışıklar ile aydınlatılmış",
    budget: "₺3.800",
    reach: "120K takipçi",
    progress: 60,
    deadline: "18/12/2025",
    status: "disputed"
  }];


  const milestones = [
  {
    id: 1,
    title: "İçerik Planlaması",
    description: "Kampanya stratejisi ve içerik takvimi oluşturulması",
    payment: "₺1.500",
    dueDate: "05/12/2025",
    status: "completed",
    completedDate: "04/12/2025",
    deliverables: [
    { id: 1, name: "İçerik takvimi", completed: true },
    { id: 2, name: "Hashtag stratejisi", completed: true },
    { id: 3, name: "Gönderi metinleri", completed: true }]

  },
  {
    id: 2,
    title: "İçerik Üretimi",
    description: "Video ve görsel içeriklerin çekimi ve düzenlenmesi",
    payment: "₺2.000",
    dueDate: "12/12/2025",
    status: "in-progress",
    deliverables: [
    { id: 4, name: "Ana video çekimi", completed: true },
    { id: 5, name: "Video düzenleme", completed: false },
    { id: 6, name: "Thumbnail tasarımı", completed: false }]

  },
  {
    id: 3,
    title: "Yayınlama ve Tanıtım",
    description: "İçeriklerin sosyal medya platformlarında yayınlanması",
    payment: "₺1.500",
    dueDate: "15/12/2025",
    status: "pending",
    deliverables: [
    { id: 7, name: "Instagram gönderisi", completed: false },
    { id: 8, name: "Story paylaşımları", completed: false },
    { id: 9, name: "Reels videosu", completed: false }]

  }];


  const analytics = {
    totalReach: "1.2M",
    engagementRate: "8.5%",
    roi: "245%",
    totalSpent: "₺35.500",
    weeklyReach: [
    { day: "Pzt", reach: 150000 },
    { day: "Sal", reach: 180000 },
    { day: "Çar", reach: 220000 },
    { day: "Per", reach: 190000 },
    { day: "Cum", reach: 250000 },
    { day: "Cmt", reach: 280000 },
    { day: "Paz", reach: 230000 }],

    platformDistribution: [
    { name: "Instagram", value: 45 },
    { name: "TikTok", value: 30 },
    { name: "YouTube", value: 20 },
    { name: "Twitter", value: 5 }],

    campaignPerformance: [
    { campaign: "Single Lansmanı", reach: 250000, engagement: 21250 },
    { campaign: "Album Tanıtımı", reach: 500000, engagement: 42500 },
    { campaign: "Konser Promosyonu", reach: 380000, engagement: 32300 },
    { campaign: "Video Lansmanı", reach: 180000, engagement: 15300 }]

  };

  const messages = [
  {
    id: 1,
    sender: "influencer",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e86918b4-1763299968198.png",
    avatarAlt: "Influencer Ayşe Yılmaz\'ın mesaj profil fotoğrafı",
    content: "Merhaba! Video çekimlerini tamamladım. Düzenleme aşamasına geçiyorum.",
    timestamp: new Date(Date.now() - 3600000)
  },
  {
    id: 2,
    sender: "you",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f04b21d4-1763300338260.png",
    avatarAlt: "Kullanıcı profil fotoğrafı",
    content: "Harika! Düzenleme tamamlandığında önizleme için gönderebilir misin?",
    timestamp: new Date(Date.now() - 3000000)
  },
  {
    id: 3,
    sender: "influencer",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e86918b4-1763299968198.png",
    avatarAlt: "Influencer Ayşe Yılmaz\'ın mesaj profil fotoğrafı",
    content: "Tabii ki! Yarın akşama kadar hazır olacak.",
    timestamp: new Date(Date.now() - 2400000)
  },
  {
    id: 4,
    sender: "you",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f04b21d4-1763300338260.png",
    avatarAlt: "Kullanıcı profil fotoğrafı",
    content: "Mükemmel, teşekkürler!",
    timestamp: new Date(Date.now() - 1800000)
  }];


  const payments = [
  {
    id: 1,
    campaignTitle: "Yeni Single Lansmanı",
    influencerName: "Ayşe Yılmaz",
    amount: "₺5.000",
    commission: "₺750",
    netAmount: "₺4.250",
    date: "15/12/2025",
    method: "Banka Transferi",
    status: "pending",
    escrow: true
  },
  {
    id: 2,
    campaignTitle: "Album Tanıtım Kampanyası",
    influencerName: "Mehmet Demir",
    amount: "₺12.000",
    commission: "₺1.800",
    netAmount: "₺10.200",
    date: "10/12/2025",
    method: "Kredi Kartı",
    status: "completed",
    escrow: false
  },
  {
    id: 3,
    campaignTitle: "Müzik Video Lansmanı",
    influencerName: "Can Özkan",
    amount: "₺6.200",
    commission: "₺930",
    netAmount: "₺5.270",
    date: "08/12/2025",
    method: "PayPal",
    status: "completed",
    escrow: false
  }];


  const dispute = {
    id: 1,
    title: "İçerik Kalitesi Anlaşmazlığı",
    campaignTitle: "Remix Tanıtımı",
    description: "Teslim edilen video içeriği, kampanya briefinde belirtilen kalite standartlarını karşılamıyor. Video çözünürlüğü düşük ve ses kalitesi yetersiz.",
    complainant: "Sanatçı - Ahmet Yıldız",
    respondent: "Influencer - Elif Şahin",
    amount: "₺3.800",
    category: "Kalite Sorunu",
    openedDate: "28/11/2025",
    status: "open",
    communications: [
    {
      id: 1,
      sender: "Ahmet Yıldız",
      date: "28/11/2025 14:30",
      message: "Video kalitesi beklentileri karşılamıyor. Yeniden çekim talep ediyorum."
    },
    {
      id: 2,
      sender: "Elif Şahin",
      date: "28/11/2025 16:45",
      message: "Teknik sorunları düzeltip yeni bir versiyon hazırlayabilirim. 2 gün süre verebilir misiniz?"
    },
    {
      id: 3,
      sender: "Ahmet Yıldız",
      date: "29/11/2025 10:15",
      message: "Tamam, 2 gün içinde yeni versiyonu bekliyorum."
    }]

  };

  const statusOptions = [
  { value: 'all', label: 'Tüm Durumlar' },
  { value: 'active', label: 'Aktif' },
  { value: 'pending', label: 'Beklemede' },
  { value: 'completed', label: 'Tamamlandı' },
  { value: 'disputed', label: 'Anlaşmazlık' }];


  const tabs = [
  { id: 'active', label: 'Aktif Kampanyalar', icon: 'PlayCircle', count: campaigns?.filter((c) => c?.status === 'active')?.length },
  { id: 'pending', label: 'Bekleyen', icon: 'Clock', count: campaigns?.filter((c) => c?.status === 'pending')?.length },
  { id: 'completed', label: 'Tamamlanan', icon: 'CheckCircle', count: campaigns?.filter((c) => c?.status === 'completed')?.length },
  { id: 'disputed', label: 'Anlaşmazlıklar', icon: 'AlertCircle', count: campaigns?.filter((c) => c?.status === 'disputed')?.length }];


  const filteredCampaigns = campaigns?.filter((campaign) => {
    const matchesTab = activeTab === 'active' ? campaign?.status === 'active' :
    activeTab === 'pending' ? campaign?.status === 'pending' :
    activeTab === 'completed' ? campaign?.status === 'completed' :
    activeTab === 'disputed' ? campaign?.status === 'disputed' : true;

    const matchesStatus = filterStatus === 'all' || campaign?.status === filterStatus;
    const matchesSearch = campaign?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    campaign?.influencerName?.toLowerCase()?.includes(searchQuery?.toLowerCase());

    return matchesTab && matchesStatus && matchesSearch;
  });

  const handleViewDetails = (campaignId) => {
    const campaign = campaigns?.find((c) => c?.id === campaignId);
    setSelectedCampaign(campaign);
    setShowMilestones(true);
  };

  const handleMessage = (campaignId) => {
    const campaign = campaigns?.find((c) => c?.id === campaignId);
    setSelectedCampaign(campaign);
    setShowMessages(true);
  };

  const handleSendMessage = (message) => {
    console.log('Sending message:', message);
  };

  const handleAttachFile = () => {
    console.log('Attaching file');
  };

  const handleUpdateMilestone = (milestoneId, deliverableId, completed) => {
    console.log('Updating milestone:', milestoneId, deliverableId, completed);
  };

  const handleApproveMilestone = (milestoneId) => {
    console.log('Approving milestone:', milestoneId);
  };

  const handleProcessPayment = (paymentId) => {
    console.log('Processing payment:', paymentId);
  };

  const handleDownloadInvoice = (paymentId) => {
    console.log('Downloading invoice:', paymentId);
  };

  const handleSubmitResponse = (response) => {
    console.log('Submitting response:', response);
  };

  const handleEscalate = () => {
    console.log('Escalating dispute');
  };

  const handleResolve = (resolution) => {
    console.log('Resolving dispute:', resolution);
  };

  const handleUpdateStatus = (campaignId, newStatus) => {
    console.log('Updating campaign status:', campaignId, newStatus);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16 pb-20 md:pb-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold text-foreground mb-2">Kampanya Yönetimi</h1>
              <p className="text-muted-foreground">Tüm kampanyalarınızı tek yerden yönetin</p>
            </div>
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                iconName="BarChart3"
                iconPosition="left"
                onClick={() => setShowAnalytics(!showAnalytics)}>

                Analitik
              </Button>
              <Button
                variant="outline"
                iconName="CreditCard"
                iconPosition="left"
                onClick={() => setShowPayments(!showPayments)}>

                Ödemeler
              </Button>
              <Button
                variant="default"
                iconName="Plus"
                iconPosition="left"
                onClick={() => navigate('/influencer-discovery')}>

                Yeni Kampanya
              </Button>
            </div>
          </div>

          <div className="bg-card border border-border rounded-lg mb-6">
            <div className="border-b border-border overflow-x-auto">
              <div className="flex items-center gap-1 p-2 min-w-max">
                {tabs?.map((tab) =>
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`
                      flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-smooth
                      ${activeTab === tab?.id ?
                  'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-muted'}
                    `
                  }>

                    <Icon name={tab?.icon} size={16} />
                    <span>{tab?.label}</span>
                    <span className={`
                      px-2 py-0.5 rounded-full text-xs font-medium
                      ${activeTab === tab?.id ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'}
                    `}>
                      {tab?.count}
                    </span>
                  </button>
                )}
              </div>
            </div>

            <div className="p-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6">
                <div className="flex-1 w-full sm:w-auto">
                  <Input
                    type="search"
                    placeholder="Kampanya veya influencer ara..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e?.target?.value)} />

                </div>
                <div className="flex items-center gap-2 w-full sm:w-auto">
                  <Select
                    options={statusOptions}
                    value={filterStatus}
                    onChange={setFilterStatus}
                    className="w-full sm:w-48" />

                  <div className="flex items-center gap-1 bg-muted rounded-md p-1">
                    <button
                      onClick={() => setViewMode('table')}
                      className={`p-2 rounded transition-smooth ${
                      viewMode === 'table' ? 'bg-background shadow-sm' : 'hover:bg-background/50'}`
                      }
                      aria-label="Tablo görünümü">

                      <Icon name="List" size={18} />
                    </button>
                    <button
                      onClick={() => setViewMode('grid')}
                      className={`p-2 rounded transition-smooth ${
                      viewMode === 'grid' ? 'bg-background shadow-sm' : 'hover:bg-background/50'}`
                      }
                      aria-label="Kart görünümü">

                      <Icon name="LayoutGrid" size={18} />
                    </button>
                  </div>
                </div>
              </div>

              {showAnalytics ?
              <div className="mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-semibold text-foreground">Kampanya Analitiği</h2>
                    <Button
                    variant="ghost"
                    size="icon"
                    iconName="X"
                    onClick={() => setShowAnalytics(false)} />

                  </div>
                  <CampaignAnalytics analytics={analytics} />
                </div> :
              showPayments ?
              <div className="mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-semibold text-foreground">Ödeme Yönetimi</h2>
                    <Button
                    variant="ghost"
                    size="icon"
                    iconName="X"
                    onClick={() => setShowPayments(false)} />

                  </div>
                  <PaymentManagement
                  payments={payments}
                  onProcessPayment={handleProcessPayment}
                  onDownloadInvoice={handleDownloadInvoice} />

                </div> :
              showMilestones && selectedCampaign ?
              <div className="mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h2 className="text-xl font-semibold text-foreground">{selectedCampaign?.title}</h2>
                      <p className="text-sm text-muted-foreground">Kilometre Taşları ve Teslim Edilecekler</p>
                    </div>
                    <Button
                    variant="ghost"
                    size="icon"
                    iconName="X"
                    onClick={() => {
                      setShowMilestones(false);
                      setSelectedCampaign(null);
                    }} />

                  </div>
                  <MilestoneTracker
                  milestones={milestones}
                  onUpdateMilestone={handleUpdateMilestone}
                  onApproveMilestone={handleApproveMilestone} />

                </div> :
              showMessages && selectedCampaign ?
              <div className="mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h2 className="text-xl font-semibold text-foreground">{selectedCampaign?.influencerName}</h2>
                      <p className="text-sm text-muted-foreground">{selectedCampaign?.title}</p>
                    </div>
                    <Button
                    variant="ghost"
                    size="icon"
                    iconName="X"
                    onClick={() => {
                      setShowMessages(false);
                      setSelectedCampaign(null);
                    }} />

                  </div>
                  <div className="bg-card border border-border rounded-lg h-[500px]">
                    <MessagePanel
                    messages={messages}
                    onSendMessage={handleSendMessage}
                    onAttachFile={handleAttachFile} />

                  </div>
                </div> :
              activeTab === 'disputed' && filteredCampaigns?.length > 0 ?
              <div className="mb-6">
                  <DisputeResolution
                  dispute={dispute}
                  onSubmitResponse={handleSubmitResponse}
                  onEscalate={handleEscalate}
                  onResolve={handleResolve} />

                </div> :
              null}

              {!showAnalytics && !showPayments && !showMilestones && !showMessages &&
              <>
                  {filteredCampaigns?.length > 0 ?
                viewMode === 'table' ?
                <CampaignTable
                  campaigns={filteredCampaigns}
                  onViewDetails={handleViewDetails}
                  onMessage={handleMessage}
                  onUpdateStatus={handleUpdateStatus} /> :


                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {filteredCampaigns?.map((campaign) =>
                  <CampaignCard
                    key={campaign?.id}
                    campaign={campaign}
                    onViewDetails={handleViewDetails}
                    onMessage={handleMessage}
                    onUpdateStatus={handleUpdateStatus} />

                  )}
                      </div> :


                <div className="text-center py-12">
                      <Icon name="Inbox" size={48} className="mx-auto mb-4 text-muted-foreground opacity-50" />
                      <h3 className="text-lg font-semibold text-foreground mb-2">Kampanya Bulunamadı</h3>
                      <p className="text-muted-foreground mb-4">
                        {searchQuery ? 'Arama kriterlerinize uygun kampanya bulunamadı.' : 'Bu kategoride henüz kampanya bulunmuyor.'}
                      </p>
                      <Button
                    variant="default"
                    iconName="Plus"
                    iconPosition="left"
                    onClick={() => navigate('/influencer-discovery')}>

                        Yeni Kampanya Oluştur
                      </Button>
                    </div>
                }
                </>
              }
            </div>
          </div>
        </div>
      </main>
      <MobileNav userRole="artist" />
      <QuickActions userRole="artist" />
    </div>);

};

export default CampaignManagement;